// extracted by mini-css-extract-plugin
export var benefits = "styles-module--benefits--yqwBt";
export var title = "styles-module--title--tvBm2";
export var item = "styles-module--item--M5syF";